import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { UiService } from '../../../../../services/core.ui.service';
import { ProjectService } from '../../../../../services/project.service';

@Component({
  selector: 'project-admin-group-delete',
  template: require('./project.admin.group.delete.html')
})
export class ProjectAdminGroupDeleteComponent implements OnInit {
  @Input() project: any;
  @Input() group: any;

  @Output() onDelete = new EventEmitter<any>();
  @Output() onClose = new EventEmitter<any>();

  constructor(
    private uiService: UiService,
    private projectService: ProjectService
  ) {}

  ngOnInit(): void {}

  deleteGroup(): void {
    this.projectService.deleteGroup(this.project.unixName, this.group.unixName)
      .then(() => {
        this.onDelete.emit();
        this.uiService.message.showSuccess('Group successfully removed', 'Remove group');
      })
      .catch(() => {
        this.uiService.message.showError('There was an error removing the group', 'Remove group');
        this.onClose.emit();
      })
      .finally(() => {});
  }

  doClose(): void { 
    this.onClose.emit(); 
  }
}
